import { genComponentStyleHook } from '../../theme/internal';
// =============================== Base ===============================
const genBaseStyle = token => {
  const {
    componentCls,
    colorText,
    fontSize,
    lineHeight,
    fontFamily
  } = token;
  return {
    [componentCls]: {
      color: colorText,
      fontSize,
      lineHeight,
      fontFamily
    }
  };
};
// ============================== Export ==============================
export default genComponentStyleHook('App', token => [genBaseStyle(token)]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/app/style/index.js
// module id = 2892
// module chunks = 0